import React from 'react';
import { PaymentLogos } from './PaymentLogos';
const DEVICE_MOCKUP_URL = 'https://cdn.magicpatterns.com/uploads/wDdDmeChXXkWa7j8AtDmCx/heylloyd-image-1774656236675.png';
export function Hero() {
  return <section className="relative w-full min-h-screen flex flex-col items-center justify-center overflow-hidden bg-black py-16 md:py-20 px-4" data-id="element-45">
      {/* ── Ambient Noise Texture ── */}
      <div className="absolute inset-0 z-0 opacity-[0.03]" style={{
      backgroundImage: 'url("data:image/svg+xml,%3Csvg viewBox=%220 0 512 512%22 xmlns=%22http://www.w3.org/2000/svg%22%3E%3Cfilter id=%22n%22%3E%3CfeTurbulence type=%22fractalNoise%22 baseFrequency=%220.75%22 numOctaves=%225%22 stitchTiles=%22stitch%22/%3E%3C/filter%3E%3Crect width=%22100%25%22 height=%22100%25%22 filter=%22url(%23n)%22/%3E%3C/svg%3E")'
    }} data-id="element-46" />

      {/* ── Chiaroscuro Amber Side Light ── */}
      <div className="absolute inset-0 z-0 pointer-events-none" style={{
      background: 'radial-gradient(ellipse 40% 80% at 5% 50%, rgba(197,160,20,0.08) 0%, transparent 70%), radial-gradient(ellipse 30% 60% at 95% 60%, rgba(30,30,50,0.3) 0%, transparent 60%)'
    }} data-id="element-47" />

      {/* ── Floating Dust Particles ── */}
      <div className="absolute inset-0 z-[5] pointer-events-none overflow-hidden" data-id="element-48">
        {[...Array(18)].map((_, i) => <div key={i} className="absolute rounded-full" style={{
        width: `${1 + Math.random() * 2}px`,
        height: `${1 + Math.random() * 2}px`,
        background: `rgba(${180 + Math.random() * 75}, ${150 + Math.random() * 60}, ${20 + Math.random() * 40}, ${0.15 + Math.random() * 0.25})`,
        left: `${Math.random() * 100}%`,
        top: `${Math.random() * 100}%`,
        animation: `float-dust ${6 + Math.random() * 10}s ease-in-out infinite`,
        animationDelay: `${Math.random() * 8}s`,
        filter: 'blur(0.5px)'
      }} data-id="element-49" />)}
      </div>

      {/* ── Main Content ── */}
      <div className="relative z-10 flex flex-col items-center justify-center text-center w-full max-w-7xl mx-auto space-y-10 md:space-y-14" data-id="element-50">
        {/* Title */}
        <div className="space-y-6" data-id="element-51">
          {/* Author Name */}
          <div className="flex flex-col items-center gap-5" data-id="element-52">
            <span className="font-['Playfair_Display'] font-bold text-xl md:text-2xl lg:text-3xl text-[#C5A014] tracking-[0.3em] uppercase" data-id="element-53">
              Sebastián Marset
            </span>
            <div className="w-24 h-[1px] bg-[#C5A014]/40" data-id="element-54" />
          </div>

          <h1 className="font-['Playfair_Display'] font-bold text-4xl md:text-6xl lg:text-7xl text-[#B8B8B8] leading-tight tracking-tight drop-shadow-[0_2px_20px_rgba(184,184,184,0.1)] max-w-5xl mx-auto" data-id="element-55">
            El narco que convirtió la burocracia uruguaya en su mejor arma.
          </h1>
          <p className="font-['Crimson_Text'] text-base md:text-xl lg:text-2xl text-zinc-400 max-w-3xl mx-auto leading-relaxed italic px-4" data-id="element-56">
            De vender a menudeo a broker logístico de 16 toneladas. La crónica
            definitiva del ascenso, el auge de hierro y la captura del primer
            gran capo uruguayo en marzo de 2026.
          </p>
        </div>

        {/* ══════════════════════════════════════════
            PHOTOREALISTIC DEVICE SHOWCASE
            ══════════════════════════════════════════ */}
        <div className="relative w-full max-w-3xl mx-auto" data-id="element-57">
          <img src={DEVICE_MOCKUP_URL} alt="MARSET: REY DEL SUR visualizado en iPad Pro y iPhone 15 Pro Max" className="w-full h-auto object-contain drop-shadow-[0_20px_60px_rgba(0,0,0,0.8)]" data-id="element-58" />
          {/* Subtle amber glow beneath devices */}
          <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-[80%] h-24 pointer-events-none" style={{
          background: 'radial-gradient(ellipse, rgba(197,160,20,0.06) 0%, transparent 70%)',
          filter: 'blur(20px)'
        }} data-id="element-59" />
        </div>

        {/* CTA Button */}
        <a href="https://templeofpages.com/checkouts/cn/hWN9tQ5DtgSWWrpyJygis6de/es-us?_r=AQABmVpcacgZYb5zSd4A0a6A2wtwNLfkCHW8pMOOTZHrBLM" target="_blank" rel="noopener noreferrer" className="inline-block bg-[#C5A014] text-black font-['Playfair_Display'] font-bold text-lg md:text-xl px-12 py-5 hover:bg-[#D4B524] transition-all duration-300 shadow-[0_0_40px_rgba(197,160,20,0.2)] hover:shadow-[0_0_60px_rgba(197,160,20,0.4)] hover:scale-105 no-underline" aria-label="Comprar el libro por 10 dólares" data-id="element-60">
          QUIERO CONOCER LA VERDAD — SOLO 6.99 USD
        </a>

        {/* ── Below-CTA Info ── */}
        <div className="flex flex-col items-center gap-2 pt-3" data-id="element-61">
          {/* Payment Logos */}
          <PaymentLogos data-id="element-62" />

          {/* Trust Badges */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-6 pt-1" data-id="element-63">
            <span className="font-['Crimson_Text'] text-xs md:text-sm text-zinc-400" data-id="element-64">
              ✅ Descarga inmediata
            </span>
            <span className="font-['Crimson_Text'] text-xs md:text-sm text-zinc-400" data-id="element-65">
              📱 Compatible con cualquier dispositivo
            </span>
            <span className="font-['Crimson_Text'] text-xs md:text-sm text-zinc-400" data-id="element-66">
              🔒 Pago 100% seguro
            </span>
          </div>

          {/* Urgency */}
          <p className="font-['Crimson_Text'] text-xs text-zinc-400 pt-1" data-id="element-67">
            ⏳ Precio de lanzamiento disponible por tiempo limitado
          </p>

          {/* Format */}
          <p className="font-['Crimson_Text'] text-xs text-zinc-500" data-id="element-68">
            Formato: PDF · Acceso inmediato tras la compra
          </p>
        </div>
      </div>

      {/* ── Keyframes ── */}
      <style data-id="element-69">{`
        @keyframes float-dust {
          0%, 100% { transform: translateY(0) translateX(0); opacity: 0; }
          10% { opacity: 1; }
          50% { transform: translateY(-40px) translateX(15px); opacity: 0.6; }
          90% { opacity: 0.1; }
        }
      `}</style>
    </section>;
}